import { render, staticRenderFns } from "./procedure.vue?vue&type=template&id=0dfac176&scoped=true"
import script from "./procedure.vue?vue&type=script&lang=js"
export * from "./procedure.vue?vue&type=script&lang=js"
import style0 from "./procedure.vue?vue&type=style&index=0&id=0dfac176&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfac176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dfac176')) {
      api.createRecord('0dfac176', component.options)
    } else {
      api.reload('0dfac176', component.options)
    }
    module.hot.accept("./procedure.vue?vue&type=template&id=0dfac176&scoped=true", function () {
      api.rerender('0dfac176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/examine/procedure.vue"
export default component.exports